import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Assistant, Workspace } from '@app-libs/model'; 
import { ConfigurationClientService } from '../client/configuration-client.service';
import { ApiClient } from '../client/api-client';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesApiService extends ApiClient {
  // Example usage

  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/workspaces';
  }

  constructor(config: ConfigurationClientService, http: HttpClient) {
    super(config, http);
  }

  // Fetch all assistants for workspace
  getWorkspacesForCurrentUser(): Observable<Workspace[]> {
    return this.http.get<Workspace[]>(`${this.baseUrl}/user`);
  }

  // Fetch the default assistant for workspace
  getDefaultAssistantForWorkspace(): Observable<Assistant> {
    return this.http.get<Assistant>(`${this.baseUrl}/workspace/default`);
  }

  // Fetch current workspace
  getCurrentWorkspace(): Observable<Workspace> {
    return this.http.get<Workspace>(`${this.baseUrl}/current`);
  }

  // Fetch a workspace by ID
  getWorkspaceById(id: string): Observable<Workspace> {
    return this.http.get<Workspace>(`${this.baseUrl}/${id}`);
  }

  // Create a new workspace
  createAssistant(workspace: Partial<Workspace>): Observable<Workspace> {
    return this.http.post<Workspace>(`${this.baseUrl}`, workspace);
  }

  // Update an workspace
  updateWorkspace(
    id: string,
    updates: Partial<Workspace>
  ): Observable<Workspace> {
    return this.http.put<Workspace>(`${this.baseUrl}/${id}`, updates);
  }

}
